import React, { useMemo, useState } from 'react';
import { Segment, Justify, Bubble, Radio } from 'tea-component';
import SearchTable from '@/pages/intelligence/pages/MarketProfile/components/MarketTableCard/SearchTable';
import CardSlot from '@/pages/intelligence/components/CardSlot';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';
import useIntlExtend from '@/pages/intelligence/hooks/useIntlExtend';
import type { RankTrendTableCProps } from '@intelligence/types/topchart';
import RankTrendTableHooks from './hooks';
import TableContent from './tablleContent';
import Loading from '@/pages/intelligence/components/Loading';
const ICON_ACTIONS = {
  default: 'tab-tip-icon',
  hover: 'action-tab-icon',
};

export default function RankTrendTableContent(props: RankTrendTableCProps) {
  const {
    tableData,
    entityType,
    tableSelection,
    setTableSelection,
    changeMarketProfileAll,
    selectAllKeys,
    setTableSearchValue,
    onSortChage,
    pageSortAttr,
    tableSearchValue,
    isTableNodata = false,
    getTableData,
    fetchParams,
    tableLoading,
    setIsOperateCheckbox,
    filterLoading,
    regionOptions,
    getLineChartData,
    rankType,
    setRankType,
    isFreeCur: isFree,
    reqDateObject,
    setBoolean,
    dataSourcesColumns,
    radioType,
    setRadioType,
    combineMarkets,
  } = props;

  // console.log('RankTrendTableContent', props);

  const [isDod, setIsDod] = useState(false);
  const [isPeriod, setIsPeriod] = useState(false);
  const { formatMessage } = useIntlExtend();
  const { setPageIndex, pageIndex, regionsCountries } = RankTrendTableHooks({
    entity_type: entityType,
    filterLoading,
    regionOptions,
  });

  const RankTrendTableContentOPTIONS = [
    {
      value: 'avg_ranking',
      text: (
        <div className="dbi-pcGame-select-flex dbi-detail-storerank-avgrank-tips">
          {formatMessage({ id: 'dbi_segment_avg_ranking' })}
          <TipContext
            className="card-slot-v2-right-tip"
            Performance="left"
            type={rankType === 'avg_ranking' ? ICON_ACTIONS : null}
            AWidth={500}
            tipText={
              <div>
                <div>
                  {formatMessage({ id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine' })}
                </div>
                <div>
                  {formatMessage({
                    id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine_steam_top_seller',
                  })}
                </div>
                <div>
                  {formatMessage({
                    id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine_epic_top_seller',
                  })}
                </div>
                <div>
                  {formatMessage({
                    id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine_playStation_best_selling',
                  })}
                </div>
                <div>
                  {formatMessage({
                    id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine_xbox_best_rated',
                  })}
                </div>
                <div>
                  {formatMessage({
                    id: 'dbi_segment_rank_trend_avg_ranking_tips_title_combine_nintendo_best_seller',
                  })}
                </div>
              </div>
            }
          />
        </div>
      ),
    },
    { value: 'latest_ranking', text: formatMessage({ id: 'dbi_segment_latest_ranking_filtered' }) },
  ];
  const radioOptions = [
    {
      value: 'dod',
      text: (
        <Bubble
          dark
          content={formatMessage({ id: 'dbi_segment_rank_trend_dod_desc' })}
          placement={'top'}
        >
          {formatMessage({ id: 'dbi_segment_rank_trend_dod' })}
        </Bubble>
      ),
    },
    {
      value: 'period',
      text: (
        <Bubble
          dark
          content={formatMessage({ id: 'dbi_segment_rank_trend_period_desc' })}
          placement={'top'}
        >
          {formatMessage({ id: 'dbi_segment_rank_trend_period' })}
        </Bubble>
      ),
    },
  ];
  const filterData = function (value: string | undefined) {
    setTableSearchValue(value);
  };

  const segmentChange = function (value: string) {
    setRankType(value);
    setPageIndex(1);
    if (value !== 'latest_ranking') {
      setBoolean(false, false);
      getTableData(fetchParams, true, value);
    }
    setIsDod(value === 'latest_ranking');
    setRadioType('dod');
  };
  const radioChange = function (value: string) {
    setRadioType(value);
    setIsDod(value === 'dod');
    setIsPeriod(value === 'period');
  };
  useMemo(() => {
    // console.log('isDod', isDod);
    // console.log('isPeriod', isPeriod);
    if (isDod || isPeriod) {
      setBoolean(true, isPeriod);
      getTableData(fetchParams, true, rankType);
    }
  }, [isDod, isPeriod]);
  return (
    <>
      <Justify
        className="dbi-pcGame-jf pc-metricstable-jf dbi-card-justify"
        left={
          <>
            <Segment
              className="segment-light details-storerank-segment"
              value={rankType}
              options={RankTrendTableContentOPTIONS}
              onChange={segmentChange}
            />
            {rankType === 'latest_ranking' ? (
              <Radio.Group value={radioType} onChange={radioChange}>
                {radioOptions.map((ele) => {
                  return (
                    <Radio key={ele.value} name={ele.value}>
                      {ele.text}
                    </Radio>
                  );
                })}
              </Radio.Group>
            ) : null}
          </>
        }
        right={
          <div className="dbi-search-table">
            <SearchTable
              countrieSelectList={combineMarkets}
              allCountriesList={combineMarkets}
              handleSearchData={(value: string) => {
                filterData(value);
                setPageIndex(1);
              }}
              regionsCountries={regionsCountries}
              defaultValue={tableSearchValue}
            />
          </div>
        }
      />
      <div className="dbi-table">
        <CardSlot className="dbi-metrics-table-container">
          {tableLoading ? (
            <Loading
              content={formatMessage({ id: 'common_loading' })}
              style={{ height: 608, color: '#444' }}
            />
          ) : (
            <TableContent
              tableData={tableData}
              isFree={isFree}
              pageIndex={pageIndex}
              setPageIndex={setPageIndex}
              tableSelection={tableSelection}
              setTableSelection={setTableSelection}
              changeMarketProfileAll={changeMarketProfileAll}
              selectAllKeys={selectAllKeys}
              regionsCountries={regionsCountries}
              onSortChage={onSortChage}
              pageSortAttr={pageSortAttr}
              setIsOperateCheckbox={setIsOperateCheckbox}
              getLineChartData={getLineChartData}
              isTableNodata={isTableNodata}
              radioType={radioType}
              rankType={rankType}
              reqDateObject={reqDateObject}
              dataSourcesColumns={dataSourcesColumns}
            />
          )}
        </CardSlot>
      </div>
    </>
  );
}
